import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../../utils/response';
import { Token, Company, EmployeeCode, UserCode, EmployeeId } from '../../../utils/users';
import { errorResponse } from '../../../utils/response';
import { GetLanguage } from '../../../utils/language';

export function listSchedule(selectedDate) {
    let url = 'schedule/listScheduleDate?' + objectToQueryString({ company: Company(), userCode: UserCode(), employeeCode: EmployeeCode(), EmployeeId: EmployeeId(), selectedDate: selectedDate, language: GetLanguage(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let listSchedule = response.list;

                //saveConfig(wage);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function listSummarySchedule(startDate, endDate) {
    let url = 'schedule/listSummaryScheduleDate?' + objectToQueryString({ company: Company(), userCode: UserCode(), employeeCode: EmployeeCode(), EmployeeId: EmployeeId(), startDate: startDate, endDate: endDate, language: GetLanguage(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let listSchedule = response.list;

                //saveConfig(wage);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}